/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

export const FileUploadHeader: Record<string, string> = {
    'accept': 'application/json;charset=UTF-8',
    'X-NODE': 'sticky',
};
